import {
  BriefcaseBusiness,
  CircleDollarSign,
  Layers3,
  ShieldCheck,
  Sparkles,
} from "lucide-react";

const mechanics = [
  {
    icon: CircleDollarSign,
    title: "Fixed LAND exchange unit",
    text: "Every AMM buy or sell moves exactly 333,333 LAND. There is no percentage cut from the LAND leg.",
  },
  {
    icon: Layers3,
    title: "Token-bound portfolio",
    text: "Each Broker controls a deterministic ERC-6551 account. Assets delivered to that account stay with the NFT.",
  },
  {
    icon: BriefcaseBusiness,
    title: "Paid activation",
    text: "Five fixed-cost tiers set reward weight. Upgrades pay only the difference; a transfer clears future eligibility.",
  },
  {
    icon: Sparkles,
    title: "Push distributions",
    text: "StockBooster and Overtime push stock tokens into active Broker accounts. There is no separate claim balance.",
  },
];

export function ProtocolPage() {
  return (
    <main className="protocol-page">
      <section className="protocol-intro">
        <span className="section-kicker">Protocol</span>
        <h1>Simple exchange units. Explicit fees.</h1>
        <p>
          A Broker is an NFT plus its token-bound account. LAND provides a fixed
          exchange unit, while ETH fees fund stock-token distributions and the
          treasury.
        </p>
      </section>

      <section className="protocol-flow" aria-label="Protocol flow">
        <span>333,333 LAND</span>
        <b>⇄</b>
        <span>Broker NFT</span>
        <b>→</b>
        <span>Activation</span>
        <b>→</b>
        <span>Stock-token drops</span>
      </section>

      <section className="protocol-content">
        <div className="mechanic-grid">
          {mechanics.map(({ icon: Icon, title, text }) => (
            <article key={title}>
              <Icon size={19} />
              <h2>{title}</h2>
              <p>{text}</p>
            </article>
          ))}
        </div>

        <article className="fee-table-section">
          <div className="protocol-section-heading">
            <span className="section-kicker">Fee structure</span>
            <h2>Launch configuration</h2>
            <p>
              Live transaction screens use current contract reads where values
              are mutable.
            </p>
          </div>
          <div
            className="fee-table"
            role="table"
            aria-label="Protocol fee structure"
          >
            <div className="fee-row fee-row-head" role="row">
              <span>Action</span>
              <span>Cost</span>
              <span>Destination</span>
            </div>
            <div className="fee-row" role="row">
              <strong>Random AMM buy or sell</strong>
              <span>10% of one-Broker ETH notional</span>
              <span>70% StockBooster · 30% treasury</span>
            </div>
            <div className="fee-row" role="row">
              <strong>Exact-ID AMM buy</strong>
              <span>15% of one-Broker ETH notional</span>
              <span>70% StockBooster · 30% treasury</span>
            </div>
            <div className="fee-row" role="row">
              <strong>External NFT sale royalty</strong>
              <span>6.66% of sale price</span>
              <span>OvertimeBooster · external payment is marketplace-dependent</span>
            </div>
            <div className="fee-row" role="row">
              <strong>Broker-backed loan</strong>
              <span>15% APY × duration, paid upfront in ETH</span>
              <span>70% StockBooster · 30% treasury</span>
            </div>
            <div className="fee-row" role="row">
              <strong>Activation</strong>
              <span>66,666–1,666,666 LAND</span>
              <span>Launch split: 50% burn · 50% treasury</span>
            </div>
          </div>
        </article>

        <aside className="risk-note">
          <ShieldCheck size={21} />
          <div>
            <h2>Read before transacting</h2>
            <p>
              Tokenized assets are not the underlying shares and can carry
              issuer, liquidity, oracle, smart-contract, and jurisdictional
              risk. Network gas and external Uniswap pool fees are
              additional.
            </p>
          </div>
        </aside>
      </section>
    </main>
  );
}
